<template>
  <div class="business-entity-input">
    <WdsInput
      v-bind="$attrs"
      v-model="internalModelValue"
      :disabled="disabled"
      :error="error"
      :label="label"
      :name="name"
      :placeholder="internalPlaceholder"
      :required="required"
    >
      <slot name="icon"></slot>
    </WdsInput>
    <slot></slot>
  </div>
</template>

<script>
import { WdsInput } from '@worksome/wds-components'
import { computed } from 'vue'

export default {
  components: {
    WdsInput,
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: $t('Registered company name'),
    },
    modelValue: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: 'business_entity_name',
    },
    placeholder: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const internalModelValue = computed({
      get() {
        return props.modelValue
      },
      set(modelValue) {
        emit('update:modelValue', modelValue)
      },
    })
    const internalPlaceholder = computed(() => props.placeholder ?? props.label)

    return {
      internalModelValue,
      internalPlaceholder,
    }
  },
}
</script>

<style lang="scss">
.business-entity-input {
  align-items: baseline;
  display: flex;

  & > div:first-child {
    width: 100%;
    & > label {
      width: 100%;
    }
  }
}
</style>
